[
  {
    "code": "SC-02",
    "name": "Anse Boileau"
  },
  {
    "code": "SC-04",
    "name": "Anse Louis"
  },
  {
    "code": "SC-05",
    "name": "Anse Royale"
  },
  {
    "code": "SC-01",
    "name": "Anse aux Pins"
  },
  {
    "code": "SC-03",
    "name": "Anse Étoile"
  },
  {
    "code": "SC-06",
    "name": "Baie Lazare"
  },
  {
    "code": "SC-07",
    "name": "Baie Sainte Anne"
  },
  {
    "code": "SC-08",
    "name": "Beau Vallon"
  },
  {
    "code": "SC-09",
    "name": "Bel Air"
  },
  {
    "code": "SC-10",
    "name": "Bel Ombre"
  },
  {
    "code": "SC-11",
    "name": "Cascade"
  },
  {
    "code": "SC-12",
    "name": "Glacis"
  },
  {
    "code": "SC-13",
    "name": "Grand' Anse (Mahé)"
  },
  {
    "code": "SC-14",
    "name": "Grand' Anse (Praslin)"
  },
  {
    "code": "SC-15",
    "name": "La Digue"
  },
  {
    "code": "SC-16",
    "name": "La Rivière Anglaise"
  },
  {
    "code": "SC-17",
    "name": "Mont Buxton"
  },
  {
    "code": "SC-18",
    "name": "Mont Fleuri"
  },
  {
    "code": "SC-19",
    "name": "Plaisance"
  },
  {
    "code": "SC-20",
    "name": "Pointe La Rue"
  },
  {
    "code": "SC-21",
    "name": "Port Glaud"
  },
  {
    "code": "SC-22",
    "name": "Saint Louis"
  },
  {
    "code": "SC-23",
    "name": "Takamaka"
  }
]